import AssistClasses from './AssistClasses.js'
import dialogs from '../common/dialogs.js'
import forms from '../common/forms.js'
import depo from '../depo'

// import client from '../client'
import StepSetParameters from './StepSetParameters.js'

class DocumnentSelectType extends AssistClasses.Step {
  constructor (cxt) {
    super('Выберите тип документа',
      (step) => step.model.deedName,
      {
        scheme: [
          {
            fieldType: 'v-text-field',
            label: 'Тип',
            name: 'deedNumber',
            hint: (model, field) => {
              return model['deedName'] || 'Введите или выберите код типа документа'
            },
            errors: (model, field) => {
              return (model['deedNumber'] !== null) && (model['deedName'] === null) && 'Неверный код типа документа' || null
            },
            events: {
              'input': (value) => {
                cxt.setDeed('deedNumber', 'deedName', value)
              }
            },
            grow: true,
            size: {sm8: true, xs6: true}
          },
          {
            fieldType: 'v-btn',
            slot: 'Выбрать',
            events: {'click': () => cxt.selectDeed('deedNumber', 'deedName')},
            shrink: false,
            size: {sm4: true, xs6: true}
          },
          {
            fieldType: 'v-select',
            label: 'Формат документа',
            itemValue: 'value',
            itemText: 'text',
            items: (model, field) => {
              return cxt.getDeedFormats()
            },
            name: 'deedFormat',
            shrink: false,
            size: {sm8: true, xs12: true}
          }
        ]
      },
      {
        deedNumber: null,
        deedName: null,
        deedFormat: 'docx'
      }
    )
    this.context = cxt
    this.nextEnabled = () => this.model['deedName'] !== null
    this.editable = true
  }
}

class DocumnentOperations extends AssistClasses.Step {
  static getOperations () {
    return [
      {value: 'DEPO', text: 'Депонировать документ'},
      {value: 'DOWNLOAD', text: 'Скачать депонированный документ'},
      {value: 'OPEN_DOC', text: 'Открыть карточку депонирования документа'},
      {value: 'UPLOAD', text: 'Загрузить исправленную версию документа'},
      {value: 'SEND', text: 'Поделиться документом'},
      {value: 'SEND_BY_SERVER', text: 'Направить письмо по электронной почте'},
      {value: 'NEW', text: 'Создать новый документ по образцу'},
      {value: 'OPEN_XML', text: 'Отладка (xml)'}
    ]
  }
  constructor (cxt) {
    super(
      'Операции над документом',
      (step) => this.fillSubTitle(step.model, step.props.scheme),
      {
        scheme: []
      },
      {
        '/email-send/options': 'DEPO_LINK'
      }
    )
    this.context = cxt
    this.nextLabel = () => 'Выполнить'
    this.editable = true
    this.macros = []
    console.log('DocumnentOperations.constructor', this)
  }
  fillSubTitle (model, fields) {
    if (model['depoLink']) {
      return this.context.getDepoUrl(model.depoLink)
    }
    if (model['deedNoContent']) {
      return 'Шаблон не предполагает документов'
    }
    return ''
  }
  fillFields (fields) {
    let lScheme = [
      {
        fieldType: 'v-select-radio',
        name: 'lastOperation',
        itemText: 'text',
        itemValue: 'value',
        items: (model) => this.getOperations(model),
        size: {sm10: true}
      }
    ]
    this.props.scheme = lScheme
    this.macros = []
    fields.forEach(f => {
      let fullFieldName = !f.target ? `${f.name}` : `/${f.target}/${f.name}`
      switch (f.type) {
        case 'macro':
          this.macros.push({k: fullFieldName, t: 'text'})
          break
        case 'html':
          this.macros.push({k: fullFieldName, t: 'html'})
          break
      }
    })
    return this
  }
  getOperations (model) {
    let ops = ['SEND_BY_SERVER', 'DEPO', 'NEW', 'OPEN_XML']
    if (model['depoLink']) {
      ops.push('OPEN_DOC', 'DOWNLOAD', 'SEND', 'UPLOAD')
    }
    return DocumnentOperations.getOperations().filter(o => ops.includes(o.value))
  }
  next (model, cb) {
    this.execute(model)
    return model
    // return nextFn(model)
  }
  execute (model) {
    const _f = (val, def) => {
      if (val == null) {
        return def
      } else {
        return val
      }
    }
    var operation = model.lastOperation
    delete model.lastOperation
    switch (operation) {
      case 'DEPO':
        dialogs.confirm(this.context, 'Подтвердите', 'Сгенерировать новые версии документов и загрузить в депозитарий?',
          (self) => {
            self.depoDoc('depoLink')
          })
        break
      case 'OPEN_DOC':
        if (model.depoLink) {
          this.context.openDoc('depoLink')
        } else {
          dialogs.message(this.context, 'Совет', 'Сначала загрузите документ в депозитарий')
        }
        break
      case 'DOWNLOAD':
        if (model.depoLink) {
          this.context.openDepo(model.depoLink)
        } else {
          dialogs.message(this.context, 'Совет', 'Сначала загрузите документ в депозитарий')
        }
        break
      case 'OPEN_XML':
        this.context.preview('xml')
        break
      case 'UPLOAD':
        let uid = model.depoLink
        depo.newFile(null, null, uid)
        break
      case 'SEND':
        if (model.depoLink) {
          depo.sendProps([model.depoLink], model['/email-send/to'], {body: model['/email-send/body'], subject: model['/email-send/subject']})
        } else {
          dialogs.message(this.context, 'Совет', 'Сначала загрузите документ в депозитарий')
        }
        break
      case 'SEND_BY_SERVER':
        model.currentStep = 3
        this.context.updateData(model)
        if (this.context.getIsAllow({SEND_MAIL: null})) {
          this.calcMacros(this.macros, model).then(obj => {
            let uids = (model['deedNoContent'] || model.depoLink === null) ? null : [model.depoLink]
            forms.openEmail({
              uids: uids,
              to: _f(obj['/email-send/to'], model['/email-send/to']),
              subject: _f(obj['/email-send/subject'], model['/email-send/subject']),
              body: _f(obj['/email-send/body'], model['/email-send/body']),
              options: model['/email-send/options'],
              mailbox: model['/email-send/mailbox']
            }).then(data => {
              let request = {
                id: this.context.getMatterId(),
                email: data.email,
                subject: data.subject,
                body: data.body,
                mailbox: data.mailbox,
                scheduled: data.scheduled,
                options: data.attach ? null : 'NO_ATTACH'
              }
              this.context.$store.dispatch('sendAssistMatter', request)
            })
          })
        } else {
          dialogs.message(this.context, 'Совет', 'Вы не можете посылать письма, сначала включите функцию рассылки для компании')
        }
        break
      case 'NEW':
        delete model.depoLink
        model.currentStep = 2
        this.context.saveAsNew(model)
        break
      case 'delete': this.context.delete()
    }
  }
  calcMacros (macros, model) {
    const calcMacro = (macro, type) => {
      return Promise.resolve(macro)
      .then(() => {
        if (/xslt:/ig.test(macro)) {
          return this.context.macro(macro)
        }
        return macro
      })
      .then(html => {
        if (/text/ig.test(type)) {
          let toDiv = document.createElement('div')
          toDiv.innerHTML = html
          return toDiv.innerText
        }
        return html
      })
    }
    return macros.reduce(
      (p, e) => {
        return p.then(obj => {
          return calcMacro(model[e.k], e.t)
          .then(data => {
            obj[e.k] = data
            return obj
          })
        })
      },
      Promise.resolve({})
    )
  }
}

class DeedStrategy extends AssistClasses.Strategy {
  getTypeCode () {
    return 'DEED'
  }
  next (model, step) {
    const cb = (model) => {
      var currentStep = step.number
      currentStep = currentStep <= this.steps.length ? currentStep + 1 : this.steps.length + 1
      model.setCurrentStep(currentStep)
      this.context.updateData(model)
      return model
    }
    return step && step.next ? step.next(model, cb) : model
  }
  getCurrentStep (model) {
    return this.steps.find(step => step.number === model.getCurrentStep())
  }
  back (model, step) {
    const cb = (model) => {
      var currentStep = step.number
      if (currentStep > 1) {
        currentStep = currentStep - 1
        model.setCurrentStep(currentStep)
        this.context.updateData(model)
      } else {
        this.context.refreshData()
      }
      return model
    }
    return step && step.back ? step.back(model, cb) : model
  }

  complete (model, step) {
    return step && model && model.getCurrentStep() > step.number
  }

  editable (model, step) {
    return step.editable || (model && model.getCurrentStep() === step.number)
  }

  previewable (model) {
    return (model && model.getCurrentStep() > 1)
  }

  updateSteps (scheme) {
    var steps = []
    var cxt = this.context
    Object.assign(new DocumnentSelectType(cxt), {backLabel: () => 'Отмена'})
    .addToArray(steps)

    if (scheme && scheme.steps && scheme.steps.length > 0) {
      new StepSetParameters.Step(cxt)
      .fillFields(scheme.steps[0].fields)
      .addToArray(steps)

      // new DocumnentCheck(cxt)
      // .addToArray(steps)

      new DocumnentOperations(cxt)
      .fillFields(scheme.steps[0].fields)
      .addToArray(steps)
    }

    this.steps = steps
    return this
  }
  updateModel (model) {
    this.steps.forEach((step) => step.setModel(model))
  }
  createModel () {
    var model = new Model()
    if (this.context) {
      model['companyInn'] = this.context.profile.clientInn
      model['companyRefCode'] = this.context.profile.clientRefCode
    }
    this.steps.forEach((step) => Object.assign(model, step.model))
    return model
  }
}

function createStrategy (cxt) {
  return new DeedStrategy(cxt)
}

class Model extends AssistClasses.Model {
  constructor () {
    super()
    this.deedNumber = null
    this.deedNoContent = false
  }

  copy () {
    return Object.assign(new Model(), this)
  }

}

export default {
  createStrategy,
  Model
}



// WEBPACK FOOTER //
// ./src/components/assist/DeedSteps.js